import { render, staticRenderFns } from "./QuizCard.vue?vue&type=template&id=0506daea&scoped=true&functional=true"
var script = {}
import style0 from "./QuizCard.vue?vue&type=style&index=0&id=0506daea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "0506daea",
  null
  
)

export default component.exports